<template>
  <div>
    <Breadcrumbs title="Transaction History" />
    <div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-header dropdown-basic">
                    <div class="dropdown pull-right">
                        <div class="btn-group mb-0">
                          <div class="dropdown-basic">
                            <b-dropdown text="New Transaction" variant="primary">
                              <b-dropdown-item><router-link to="/transfers/own-account-transfer">Own Account Transfer</router-link></b-dropdown-item>
                              <b-dropdown-item><router-link to="/transfers/local-transfer">TAJBank Transfer</router-link></b-dropdown-item>
                              <b-dropdown-item><router-link to="/transfers/interbank-transfer">Interbank Transfer</router-link></b-dropdown-item>
                            </b-dropdown>
                        </div>
                        </div>
                    </div>
                    <h5>Manage Transactions</h5>
                    <span>Manage all Transactions. Use the filters to search list.</span>

                </div>
                <div class="card-body">
                    <form class="form-space theme-form row mb-3" id="FilterTransactions_Form">
                        <div class="col-md-4">
                            <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text"><i class="feather icon-briefcase text-danger"></i></span>
                            </div>
                                <select v-model="form.accountNumber" @change="selectAccounNumber" class="custom-select acct-num" required="required"><option value="">Select From Account *</option>
                                  <option v-for="account in userAccounts" :value="account.accountNumber" :key="account.id">{{account.accountNumber}} (Acct No: {{account.accountName}} | Balance: {{account.availableBalance}})</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text"><i class="feather icon-calendar text-danger"></i></span>
                                <datepicker placeholder="Transactions From"  input-class="datepicker-here form-control digits" :format="format" v-model="form.startDate" ></datepicker>
                            </div>
                                <!--<input class="datepicker-here form-control digits" data-language="en" type="text" id="StartDate" placeholder="Transactions From"   >
                            --></div>
                        </div>
                        <div class="col-md-4">
                            <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text"><i class="feather icon-calendar text-danger"></i></span>
                                <datepicker placeholder="Transactions To"  input-class="datepicker-here form-control digits" :format="format" v-model="form.endDate" ></datepicker>
                            </div>  
                              <!--<input id="EndDate" class="datepicker-here form-control digits" data-language="en" type="text" placeholder="Transactions To"  >
                            --></div>
                        </div>
                        <div class="col-md-4 mt-3 col-12">
                            <button @click="getTransactionList" type="button" class="btn btn-success waves-effect waves-light"><i class="fa fa-search"></i> &nbsp;Search</button>
                        </div>
                    </form>
                    <div class="table-responsive mt-0">
                    <table id="example" class="display table table-striped" style="width:100%">
                      <thead class="font-weight-bold">
                        <tr class="text-left">
                          <th>Account Number</th>
                          <th>Destination Acct No</th>
                          <th>Destination Bank Name</th>
                          <th>Destination Acct Name</th>
                          <th>Transaction Type</th>
                          <th>Transaction Reference</th>
                          <th>Amount</th>
                          <th>Transaction Date</th>
                          <th>Status</th>
                          <th width="1%"></th>
                        </tr>
                      </thead>
                    <tbody>
                    <tr class="text-left" v-for="transaction in transactionList" :key="transaction.id">
                        <td>{{ transaction.debitAccountNumber }}</td>
                        <td>{{ transaction.creditAccountNumber ? transaction.creditAccountNumber : 'N/A'}}</td>
                        <td>{{ transaction.destinationBankName ? transaction.destinationBankName : 'N/A'}}</td>
                        <td>{{ transaction.creditAccountName ? transaction.creditAccountName : 'N/A'}}</td>
                        <td>{{ transaction.transactionType === 1 ? 'Own Account Transfer' : transaction.transactionType === 2 ? 'TAJBank Transfer' : transaction.transactionType === 3 ? 'Interbank Transfer' : transaction.transactionType === 4 ? 'Bills Payment' : transaction.transactionType === 5 ? 'Airtime Purchase' : transaction.transactionType === 6 ? 'Bulk Transfer' : transaction.transactionType === 11 ? 'Standing Instruction' : transaction.transactionType === 12 ? 'Fund Account' : transaction.transactionType == 13 ? 'Token Request' : transaction.transactionType == 14 ? 'Cheque Request' : transaction.transactionType == 17 ? 'Flight Payment' : transaction.transactionType == 18 ? 'Hotel Payment' : transaction.transactionType == 16 ? 'Lifestyle Payment' : 'Limit Upgrade' }}</td>
                        <td>{{ transaction.transactionReference }}</td>
                        <td :class="transaction.type === 'C' ? 'text-success' : 'text-danger'">{{new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN'}).format(transaction.amount)}}</td>
                        <td>{{ transaction.createdDate | moment}}</td>
                        <td :class="transaction.status === 0 ? 'text-success' : 'text-danger'">{{ transaction.status === 0 ? 'SUCCESSFUL' : 'FAILED' }}</td>
                        <td data-toggle="modal" @click="getDetails(transaction)" data-target="#transactionDetailsModalCenter" data-placement="top" title="View" ><i class='fa fa-eye primary-color'></i></td>
                    </tr>
                    </tbody>
                </table>
                </div>
                <div v-if="loading" class="text-center mt-4 text-success">
                  <i class='fa fa-refresh fa-spin'></i>&nbsp;Please Wait...
                </div>
                <div class="text-center mt-4 text-danger" ref="noTransaction"></div>
              </div>
            </div>
        </div>
    </div>
</div>
<!-- Container-fluid Ends-->

<!-- Modal Transaction Details -->
<div class="modal fade" id="transactionDetailsModalCenter" tabindex="-1" role="dialog" aria-labelledby="transactionDetailsModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-centered modal-dialog-scrollable" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title pl-2" id="addUserCenterTitle" style="font-size: 20px">Transaction Details</h5>
                <button class="close text-dark" type="button" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-md-12">
                        <div class="card-content">
                            <div id="transactionDetailsBody" class="align-content-center align-items-center justify-content-center p-2">
                                <!-- Transaction Details will be loaded here -->
                                <h5 class="ref-text">TRANSACTION REFERENCE: {{transactionDetails.transactionReference}}</h5>
                                <table class="table views-table table-striped">
                                  <tbody>
                                    <tr class="transaction-table">
                                      <td>Recipient Account Name: <span class="font-weight-bold"><br>{{transactionDetails.creditAccountName ? transactionDetails.creditAccountName : 'N/A'}}</span></td>
                                      <td>Account Number: <span class="font-weight-bold"><br>{{transactionDetails.creditAccountNumber ? transactionDetails.creditAccountNumber : 'N/A'}}</span></td>
                                      <td>Recipient Bank: <span class="font-weight-bold"><br>{{transactionDetails.destinationBankName ? transactionDetails.destinationBankName : 'N/A'}}</span></td>
                                    </tr>
                                    <tr>
                                      <td>Sender's Account Name: <span class="font-weight-bold"><br>{{transactionDetails.debitAccountName}}</span></td>
                                      <td>Account Number: <span class="font-weight-bold"><br>{{transactionDetails.debitAccountNumber}}</span></td>
                                      <td>Amount: <span class="font-weight-bold"><br>{{new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN'}).format(transactionDetails.amount)}}</span></td>
                                    </tr>
                                    <tr class="transaction-table">
                                      <td>Transaction Type: <span class="font-weight-bold"><br>{{ transactionDetails.transactionType === 1 ? 'Own Account Transfer' : transactionDetails.transactionType === 2 ? 'TAJBank Transfer' : transactionDetails.transactionType === 3 ? 'Interbank Transfer' : transactionDetails.transactionType === 4 ? 'Bills Payment' : transactionDetails.transactionType === 5 ? 'Airtime Purchase' : transactionDetails.transactionType === 6 ? 'Bulk Transfer' : transactionDetails.transactionType === 11 ? 'Standing Instruction' : transactionDetails.transactionType === 12 ? 'Fund Account' : transactionDetails.transactionType == 13 ? 'Token Request' : transactionDetails.transactionType == 14 ? 'Cheque Request' : transactionDetails.transactionType == 17 ? 'Flight Payment' : transactionDetails.transactionType == 18 ? 'Hotel Payment' : transactionDetails.transactionType == 16 ? 'Lifestyle Payment' : 'Limit Upgrade' }}</span></td>
                                      <td>Biller: <span class="font-weight-bold"><br>{{transactionDetails.biller ? transactionDetails.biller : 'N/A'}}</span></td>
                                      <td>Transaction Date: <span class="font-weight-bold"><br>{{transactionDetails.createdDate | moment}}</span></td>
                                    </tr>
                                  </tbody>
                                </table>
                                <div class="session-sec" v-if="transactionDetails.sessionId">Session ID: <span class="font-weight-bold">{{transactionDetails.sessionId ? transactionDetails.sessionId : 'N/A'}}</span></div>
                                <div class="narration-sec" v-if="transactionDetails.paymentToken">Token: <span class="font-weight-bold">{{transactionDetails.paymentToken ? transactionDetails.paymentToken : 'N/A'}}</span></div>
                                <div class="narration-sec" v-if="transactionDetails.requestID">PNR Number: <span class="font-weight-bold">{{transactionDetails.requestID ? transactionDetails.requestID : 'N/A'}}</span></div>
                                <div class="narration-sec">Narration: <span class="font-weight-bold"><br>{{transactionDetails.narration ? transactionDetails.narration : 'N/A'}}</span></div>
                                <div class="text-center">
                                  <button class="btn btn-success mt-3" type="button" @click="downloadReceipt"><i class="fa fa-download mr-1"></i>Download Receipt</button>
                              </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
  <!-- transaction receipt -->
  <div>
    <vue-html2pdf
        :show-layout="false"
        :float-layout="true"
        :enable-download="true"
        :preview-modal="false"
        :paginate-elements-by-height="1400"
        filename="transaction_receipt"
        :pdf-quality="2"
        :manual-pagination="false"
        pdf-format="a4"
        pdf-orientation="portrait"
        pdf-content-width="100%"
        @hasStartedGeneration="hasStartedGeneration()"
        @hasGenerated="hasGenerated($event)"
        ref="html2Pdf"
    >
        <section slot="pdf-content">
          <transactionReceipt :details="transactionDetails"></transactionReceipt>
        </section>
    </vue-html2pdf>
  </div>
  </div>
</template>
<script>
  import Datepicker from 'vuejs-datepicker';
  import { mapState } from 'vuex';
  import moment from 'moment';
  import VueHtml2pdf from 'vue-html2pdf';
  import transactionReceipt from './transaction-receipt/transaction-receipt.vue';
  import { decrypt } from '@/_services/encryption';
  export default {
    components: {
      Datepicker,
      VueHtml2pdf,
      transactionReceipt
    },
    filters: {
      moment: function (date) {
        return moment(date).format('YYYY-MM-DD hh:mm:A');
      }
    },
    data:()=>({
      format: 'yyyy-MM-dd',
      form: {
        accountNumber: '',
        startDate: '',
        endDate: '',
        channel: null,
        pageSize: 100,
        pageIndex: 0,
      },
      transactionDetails: {
        transactionReference: '',
        transactionType: '',
        amount: '',
        biller: '',
        billerName: '',
        createdDate: '',
        creditAccountNumber: '',
        creditAccountName: '',
        debitAccountName: '',
        debitAccountNumber: '',
        destinationBankName: '',
        narration: '',
        paymentToken: '',
        status: '',
        sessionId: '',
        type: '',
        requestID: ''
      },
      totalRows: 1,
      selectedChannelId: null,
      transactionList: [],
      loading: false,
      tableHead: false,
      getAccountNumber: '',
    }),
    computed: {
      ...mapState({
        account: (state) => state.dashboard.dashboardData,
      }),
      userAccounts(){
        return this.account ? this.account.accounts : null;
      },
      transactionStatus() {
        let status = '';
        this.transactionList.forEach(transaction => {
          transaction.status === 0 ? status = 'SUCCESSFUL' : status = 'FAILED';
        });
        return status;
      },
      transactionTypeText() {
        let type = '';
        this.transactionList.forEach(transaction => {
          transaction.transactionType === 1 ? type = 'Own Account Transfer' 
          : transaction.transactionType === 2 ? type = 'TAJBank Transfer'
            :transaction.transactionType === 3 ? type = 'Interbank Transfer' 
              : transaction.transactionType === 4 ? type = 'Bill Payment' 
                : transaction.transactionType === 5 ? type = 'Airtime Purchase'
                  : 'Fund Account';
        });
        return type;
      },
    },
    mounted() {
      this.$store.dispatch('dashboard/getDashboardData').then(response => {
        if(response.status === 200) {
          this.userAccounts.forEach(account => {
            this.getAccountNumber = account.accountNumber;
          });
          const newDate = new Date();
          const monthBefore = newDate.setMonth(newDate.getMonth() - 1);
          const data = {
            accountNumber: this.getAccountNumber,
            startDate: moment(monthBefore).format('YYYY-MM-DD'),
            endDate: moment(new Date()).format('YYYY-MM-DD'),
            channel: null,
            pageSize: this.form.pageSize,
            pageIndex: this.form.pageIndex,
            status: null,
          };
          try {
            this.loading = true;
            this.$store.dispatch('dashboard/getTransactionListData', data).then(response => {
              const decryptedData = decrypt(response);
              const userParseData = JSON.parse(decryptedData);
              this.loading = false;
              this.transactionList = userParseData.transactions;
              if(userParseData.transactions.length === 0){
                this.$refs.noTransaction.innerHTML = 'No Transactions Found';
              }
            });
          } catch(error) {
            const decryptedError = decrypt(error.response.data);
            const objError = JSON.parse(decryptedError);
            this.$swal({
              title: 'Oops...',
              text: objError.errors[0],
              type: 'error',
              confirmButtonText: 'Ok'
            });
          }
        }
      });
    },
    methods: {
      downloadReceipt(){
        // download receipt with js pdf
        this.$refs.html2Pdf.generatePdf();
      },
      selectAccounNumber(event) {
        const accountNumber = event.target.value;
        const newDate = new Date();
        const monthBefore = newDate.setMonth(newDate.getMonth() - 1);
        const data = {
          accountNumber: accountNumber,
          startDate: moment(monthBefore).format('YYYY-MM-DD'),
          endDate: moment(new Date()).format('YYYY-MM-DD'),
          channel: null,
          pageSize: this.form.pageSize,
          pageIndex: this.form.pageIndex,
          status: null,
        };
        try {
          this.loading = true;
          this.$store.dispatch('dashboard/getTransactionListData', data).then(response => {
            this.loading = false;
            const decryptedData = decrypt(response);
            const userParseData = JSON.parse(decryptedData);
            this.transactionList = userParseData.transactions;
            if(userParseData.transactions.length === 0){
              this.$refs.noTransaction.innerHTML = 'No Transactions Found';
            }
          });
        } catch(error) {
          const decryptedError = decrypt(error.response.data);
          const objError = JSON.parse(decryptedError);
          this.$swal({
            title: 'Oops...',
            text: objError.errors[0],
            type: 'error',
            confirmButtonText: 'Ok'
          });
        }
      },
      getDetails(val) {
        this.transactionDetails.transactionReference = val.transactionReference;
        this.transactionDetails.transactionType = val.transactionType;
        this.transactionDetails.amount = val.amount;
        this.transactionDetails.biller = val.biller;
        this.transactionDetails.billerName = val.billerName;
        this.transactionDetails.createdDate = val.createdDate;
        this.transactionDetails.creditAccountNumber = val.creditAccountNumber;
        this.transactionDetails.creditAccountName = val.creditAccountName;
        this.transactionDetails.debitAccountName = val.debitAccountName;
        this.transactionDetails.debitAccountNumber = val.debitAccountNumber;
        this.transactionDetails.destinationBankName = val.destinationBankName;
        this.transactionDetails.narration = val.narration;
        this.transactionDetails.paymentToken = val.paymentToken;
        this.transactionDetails.status = val.status;
        this.transactionDetails.sessionId = val.nipSessionID;
        this.transactionDetails.type = val.type;
        this.transactionDetails.requestID = val.requestID;
      },
      getTransactionList() {
        const data = {
          accountNumber: this.form.accountNumber,
          startDate: moment(this.form.startDate).format('YYYY-MM-DD'),
          endDate: moment(this.form.endDate).format('YYYY-MM-DD'),
          channel: null,
          pageSize: this.form.pageSize,
          pageIndex: this.form.pageIndex,
          status: null,
        };
        // validate all fields
        if(this.form.accountNumber === '' || this.form.startDate === '' || this.form.endDate === ''){
          // show error with sweet alert
          this.$swal({
            title: 'Oops...',
            text: 'Please fill all fields',
            type: 'error',
            confirmButtonText: 'Ok'
          });
          return;
        }
        // dispatch action to get transaction list
        try {
          this.loading = true;
          this.$store.dispatch('dashboard/getTransactionListData', data).then(response => {
            const decryptedData = decrypt(response);
            const userParseData = JSON.parse(decryptedData);
            if(userParseData){
              this.resetForm();
            }
            this.loading = false;
            this.transactionList = userParseData.transactions;
            if(userParseData.transactions.length === 0){
              this.$refs.noTransaction.innerHTML = 'No Transactions Found';
            }
          });
        } catch(error) {
          const decryptedError = decrypt(error.response.data);
          const objError = JSON.parse(decryptedError);
          this.$swal({
            title: 'Oops...',
            text: objError.errors[0],
            type: 'error',
            confirmButtonText: 'Ok'
          });
        }
      },
      // reset form
      resetForm() {
        this.form.accountNumber = '';
        this.form.startDate = '';
        this.form.endDate = '';
        this.form.channel = null;
      },
    }
  };
</script>
<style scoped>
.form-control {
  background-color: #fff !important;
}
.table {
  width: 100%;
  margin-top: 1.5rem !important;
}
.primary-color {
  color: #E41613;
  cursor: pointer;
}
.dropdown-basic .dropdown .dropdown-menu a {
  padding: 5px 7px !important;
}
.vdp-datepicker {
  width: 300px !important;
}
.table-responsive > .table {
  border: 1px solid #eceeef;
}
.modal-header {
  background: #E6E6E6;
  color: #E41613;
}
.ref-text {
  color: #000;
  font-size: 16px;
}
.table-striped tbody .transaction-table:nth-of-type(odd) {
  background: #FEF7F7;
  color: #000;
}
.table td {
  border: 0 !important;
}
.table th {
  font-weight: 900 !important;
}
.views-table td {
  padding: 20px !important;
}
.narration-sec {
  padding: 20px 17px !important;
  color: #000;
}
.session-sec {
  padding: 20px 17px !important;
  color: #000;
  padding-bottom: 0 !important;
}
@media screen and (max-width: 768px) {
  #FilterTransactions_Form {
    gap: 10px;
  }
  .vdp-datepicker {
    width: 260px !important;
  }
}
</style>